import * as types from './types';

const initialState = {
  list: [],
  autoDeleteTime: 10000,
};

type ToastAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.ToastState>;
};

export default function toastsReducer(state = initialState, action: ToastAction) {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_TOAST:
      return { ...state, list: [...state.list, payload] };
    case types.REMOVE_TOAST:
      return { ...state, list: state.list.filter((item: types.Toast) => item.id !== payload) };
    default:
      return state;
  }
}
